import { render, staticRenderFns } from "./etcWithdraw.vue?vue&type=template&id=3ff1943f&scoped=true&"
import script from "./etcWithdraw.vue?vue&type=script&lang=js&"
export * from "./etcWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./etcWithdraw.vue?vue&type=style&index=0&id=3ff1943f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff1943f",
  null
  
)

export default component.exports